import React, {useEffect, useState} from 'react';
import {Form, Row, Col, Button} from 'react-bootstrap';
import {useForm, FormProvider} from 'react-hook-form';
import {Link} from 'react-router-dom';
import { commerce } from '../../lib/commerce';
import InputTextField from './InputTextField';

const AddressForm = ({checkoutToken, next}) => {
    const methods = useForm();
    const [shippingCountries, setShippingCountries] = useState([]);
    const [shippingCountry, setShippingCountry] = useState('');
    const [shippingStates, setShippingStates] = useState([])
    const [shippingState, setShippingState] = useState('')
    const [shippingOptions, setShippingOptions] = useState([])
    const [shippingOption, setShippingOption] = useState('')

  const countries = Object.entries(shippingCountries).map(([key, value])=> ({id:key, label:value}))
  const states = Object.entries(shippingStates).map(([key, value])=> ({id:key, label:value}))
  const options = shippingOptions.map((sOption)=>({id:sOption.id, label: `${sOption.description} - (${sOption.price.formatted_with_symbol})`}))
  
  const fetchShippingCountries = async (checkoutTokenId) => {
    const { countries } = await commerce.services.localeListShippingCountries( checkoutTokenId);
    setShippingCountries(countries);
    setShippingCountry(Object.keys(countries)[0]);
  };

  const fetchStates = async (countryCode) => {
    const { subdivisions } = await commerce.services.localeListSubdivisions(countryCode);
    setShippingStates(subdivisions);
    setShippingState(Object.keys(subdivisions)[0]);
  };
  
  const fetchShippingOptions = async ( checkoutTokenId,country,region = null) => {
    const options = await commerce.checkout.getShippingOptions(
      checkoutTokenId,
      { country, region }
    );

    setShippingOptions(options);
    setShippingOption(options[0].id);
  };

  useEffect(() => {
    fetchShippingCountries(checkoutToken.id);
  }, []);

  useEffect(() => {
    if (shippingCountry) fetchStates(shippingCountry);
  }, [shippingCountry]);

  useEffect(() => {
    if (shippingState)
      fetchShippingOptions(
        checkoutToken.id,
        shippingCountry,
        shippingState
      );
  }, [shippingState]);


  return (
    <>
    <h3 style={{alignText:'center'}} className='mb-4'>Shipping Address</h3>
    <FormProvider {...methods}>
        <Form onSubmit={methods.handleSubmit((data)=> next({...data, shippingCountry, shippingState, shippingOption}))}>
            <Row>
                <InputTextField name='firstName' label='First Name' />
                <InputTextField name='lastName' label='Last Name' />
                <InputTextField name='address1' label='Address' />
                <InputTextField name='email' label='Email' />
                <InputTextField name='city' label='City' />
                <InputTextField name='zip' label='ZIP' />
            </Row>
            <Row>
              <Form.Group className='mb-3'>
              <Form.Label>Shipping Country</Form.Label>
              <Form.Select value={shippingCountry} onChange={(e)=> setShippingCountry(e.target.value)}>
                  {countries.map((country)=>(
                    <option key={country.id} value={country.id}>{country.label}</option>
                  ))}
                </Form.Select>
                </Form.Group>
            </Row>
            <Row>
              <Form.Group className='mb-3'>
              <Form.Label>State</Form.Label>
              <Form.Select value={shippingState} onChange={(e)=> setShippingState(e.target.value)}>
                  {states.map((state)=>(
                    <option key={state.id} value={state.id}>{state.label}</option>
                  ))}
                </Form.Select>
                </Form.Group>
            </Row>
            <Row>
              <Form.Group className='mb-3'>
              <Form.Label>Shipping Options</Form.Label>
              <Form.Select value={shippingOption} onChange={(e)=> setShippingOption(e.target.value)}>
              {options.map((option)=>(
                    <option key={option.id} value={option.id}>{option.label}</option>
                  ))}
                </Form.Select>
                </Form.Group>
            </Row>
            <br/>
            <div className='mb-5' style={{display:'flex', justifyContent:'space-between'}}>
                <Link to="/cart"><Button variant="outline-secondary">Back to Cart</Button></Link>
                <Button type="submit" color="primary" >Next</Button>
            </div>
        </Form>
    </FormProvider>
    </>
  )
}

export default AddressForm;
